import React, { useState } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import './NudgeBanner.css';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

// Dismissible in-app re-engagement banner. Rendered from the launch-time
// profile response (GET /profile) when an inAppNudge <30d old is present and
// the user hasn't dismissed it. No new API routes — piggybacks the profile
// fetch the app already does on open. See shared-docs/re-engagement-nudges.md.
export default function NudgeBanner() {
  const { profile } = useSubscription();
  const nudge = profile?.inAppNudge;

  const dismissedKey = nudge ? `nudgeDismissed:${nudge.id}` : null;
  const [dismissed, setDismissed] = useState(() => {
    if (!dismissedKey) return false;
    try {
      return localStorage.getItem(dismissedKey) === '1';
    } catch {
      return false;
    }
  });

  if (!nudge || !nudge.id || dismissed) return null;
  // Ignore stale notices (>30 days old).
  if (nudge.createdAt && Date.now() - nudge.createdAt > THIRTY_DAYS_MS) return null;

  const dismiss = () => {
    try {
      if (dismissedKey) localStorage.setItem(dismissedKey, '1');
    } catch {}
    setDismissed(true);
  };

  return (
    <div className="nudge-banner" role="status">
      <div className="nudge-banner-text">
        {nudge.title && <div className="nudge-banner-title">{nudge.title}</div>}
        {nudge.body && <div className="nudge-banner-body">{nudge.body}</div>}
      </div>
      <button
        type="button"
        className="nudge-banner-close"
        aria-label="Dismiss"
        onClick={dismiss}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M4 4l8 8M12 4l-8 8"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
